import type { SchemaBuilderFieldContextValue } from "./schema-builder-field.type";

import { createContext, useContext } from "react";

export const config = {
  contextName: "SchemaBuilderFieldContext",
  providerName: "SchemaBuilderFieldProvider",
};

export const SchemaBuilderFieldContext =
  createContext<SchemaBuilderFieldContextValue | null>(null);

export const useSchemaBuilderFieldContext = () => {
  const contextValue = useContext(SchemaBuilderFieldContext);

  if (!contextValue) {
    throw new Error(
      `${config.contextName} must be used within a ${config.providerName}`
    );
  }

  return contextValue;
};
